function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { ErrorMessage, Field } from 'formik';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import ErrorText from '../ErrorText';
import DateSelect from './DateSelect';
import Description from './Description';
import FormGroup from './FormGroup';
import Label from './Label';
const DateSelectFormGroup = /*#__PURE__*/memo(_ref => {
  let {
    name,
    label,
    description,
    type = 'text',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(FormGroup, null, !!label && /*#__PURE__*/React.createElement(Label, null, label), /*#__PURE__*/React.createElement(Field, _extends({
    name: name,
    component: DateSelect,
    type: type
  }, props)), !!description && /*#__PURE__*/React.createElement(Description, null, description), /*#__PURE__*/React.createElement(ErrorMessage, {
    name: name,
    component: ErrorText
  }));
});
DateSelectFormGroup.propTypes = {
  description: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string
};
DateSelectFormGroup.displayName = 'DateSelectFormGroup';
export default DateSelectFormGroup;